import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

import "./invest.css";


  
  
export default function Invbox() {
  
  
  const changeText = (text) => setButtonText(text);
  const changeT = (text) => setButtonT(text);
  // invest amount & profit%
  const amount = (text) => amountRupee(text);
  const profit = (text) => profitPer(text);
  const [amountText, amountRupee] = useState("₹5000");
  const [profitText, profitPer] = useState("0.058%");
  // for proceed button
  const vLink = (string) => varLink(string);
  const [link,varLink] = useState('https://pages.razorpay.com/pl_G65B9HnENOWX1T/view')
  // ---------------------------------
  // slider value
  const sValue = (int) => sval(int);
  const [value, sval] = useState(5000);

  const paylink = [{
                      id: 1,l1:'https://pages.razorpay.com/pl_G65B9HnENOWX1T/view'
                  },
                {
                      id: 2, l2:'https://pages.razorpay.com/pl_G65HVyFbLsuUaC/view'
                },
              {
                      id: 3, l3:'https://pages.razorpay.com/pl_G65GSqEkxKlFV9/view'
              },
              {
                      id: 4, l4:'https://pages.razorpay.com/pl_G65Er6nXDOLNhc/view'
              },
              {
                      id: 5, l5:'https://pages.razorpay.com/pl_G653xqAKW62b8c/view'
              }]

  const f1 = paylink.find(obj =>{
    return obj.id === 1;
  });
  const f2 = paylink.find(obj =>{
     return obj.id === 2;
  });
  const f3 = paylink.find(obj =>{
    return obj.id === 3;
 });
 const f4 = paylink.find(obj =>{
  return obj.id === 4;
});
const f5 = paylink.find(obj =>{
  return obj.id === 5;
});


  const getValue = (e,val) => {
    
    if (val===5000){
         setColor1("#147CE5");setTxtClr1('white');setTxtClr2('black');setTxtClr3('black');setTxtClr4('black');setTxtClr5('black');changeText("₹584");changeT("₹2336");setColor2("white");setColor3("white");setColor4("white");setColor5("white");amount("₹5000");profit("0.058%"); 
         sValue(5000);
         vLink(f1.l1);
        }

    else if(val===10000){
         setColor2("#147CE5");setTxtClr1('black');setTxtClr2('white');setTxtClr3('black');setTxtClr4('black');setTxtClr5('black');changeText("₹1168");changeT("₹4672");setColor1("white");setColor3("white");setColor4("white");setColor5("white");amount("₹10000");profit("0.116%");
         sValue(10000);
         vLink(f2.l2);
}

    else if(val===15000){
         setColor3("#147CE5");setTxtClr1('black');setTxtClr2('black');setTxtClr3('white');setTxtClr4('black');setTxtClr5('black');changeText("₹1752");changeT("₹7009");setColor1("white");setColor2("white");setColor4("white");setColor5("white");amount("₹15000");profit("0.174%");
         sValue(15000);
         vLink(f3.l3);
        }
    else if(val===20000){
         setColor4("#147CE5");setTxtClr1('black');setTxtClr2('black');setTxtClr3('black');setTxtClr4('white');setTxtClr5('black');changeText("₹2336");changeT("₹9345");setColor1("white");setColor2("white");setColor3("white");setColor5("white");amount("₹20000");profit("0.232%");
         sValue(20000);
         vLink(f4.l4);
        }
    else {
         setColor5("#147CE5");setTxtClr1('black');setTxtClr2('black');setTxtClr3('black');setTxtClr4('black');setTxtClr5('white');changeText("₹2920");changeT("₹11681");setColor1("white");setColor2("white");setColor3("white");setColor4("white");amount("₹25000");profit("0.29%")
         sValue(25000);
         vLink(f5.l5);
        }

  }
 
  
  // ----------------------------------
  const [buttonText, setButtonText] = useState("₹584");
  const [buttonT, setButtonT] = useState("₹2336");
  const [color1,setColor1]=useState('#147CE5');
  const [color2,setColor2]=useState('white');
  const [color3,setColor3]=useState('white');
  const [color4,setColor4]=useState('white');
  const [color5,setColor5]=useState('white');
  const [txtclr1,setTxtClr1]=useState('white');
  const [txtclr2,setTxtClr2]=useState('black');
  const [txtclr3,setTxtClr3]=useState('black');
  const [txtclr4,setTxtClr4]=useState('black');
  const [txtclr5,setTxtClr5]=useState('black');
  return (
    <div>
    <Box

      sx={theme => ({ [theme.breakpoints.up('sm')]:{width: 460, height: 550,backgroundColor: "white",borderRadius: 1,boxShadow: 4, marginLeft:25},
                      [theme.breakpoints.between('0','600')]:{marginTop:10,marginRight:'auto', marginLeft:'auto',width: 355, height: 550,backgroundColor: "white",borderRadius: 1,boxShadow: 3}
                      })}
       >
      
      <div className="boxcontent">
      <div className="head1">
        {/* <b style={{ fontWeight:900}}>Invest Now</b> */}
      </div>
      
      {/* <p style={{fontSize:'0.9rem'}}>Choose the amount to investment</p> */}
      
      <Box
         
         sx={theme => ({ [theme.breakpoints.up('sm')]:{width : 435,height: 200,marginTop:0,backgroundColor: "#202020",marginLeft:'-2.7%'},
                      [theme.breakpoints.between('0','600')]:{width : 335,height: 230,marginTop:0,backgroundColor: "#202020", marginLeft:'-4%'}
                      })}
         >
           <div className="sbcontent">
              
              <b style={{ fontWeight:400,color:'white',fontFamily:'Roboto'}}>Investment Amount</b>
              
              <button id ='1'  className="gbutton" style={{background:color1,color:txtclr1,cursor:'pointer'}}  onClick={()=> {setColor1("#147CE5");setTxtClr1('white');setTxtClr2('black');setTxtClr3('black');setTxtClr4('black');setTxtClr5('black');changeText("₹584");changeT("₹2336");setColor2("white");setColor3("white");setColor4("white");setColor5("white");amount("₹5000");profit("0.058%");sValue(5000);vLink(f1.l1);}}>₹5000</button>
              <button id ='2'  className="gbutton" style={{background:color2,color:txtclr2,cursor:'pointer'}}  onClick={()=> {setColor2("#147CE5");setTxtClr1('black');setTxtClr2('white');setTxtClr3('black');setTxtClr4('black');setTxtClr5('black');changeText("₹1168");changeT("₹4672");setColor1("white");setColor3("white");setColor4("white");setColor5("white");amount("₹10000");profit("0.116%");sValue(10000);vLink(f2.l2);}}>₹10000</button>
              <button id ='3'  className="gbutton" style={{background:color3,color:txtclr3,cursor:'pointer'}}  onClick={()=> {setColor3("#147CE5");setTxtClr1('black');setTxtClr2('black');setTxtClr3('white');setTxtClr4('black');setTxtClr5('black');changeText("₹1752");changeT("₹7009");setColor1("white");setColor2("white");setColor4("white");setColor5("white");amount("₹15000");profit("0.174%");sValue(15000);vLink(f3.l3);}}>₹15000</button>
              <button id ='4'  className="gbutton" style={{background:color4,color:txtclr4,cursor:'pointer'}}  onClick={()=> {setColor4("#147CE5");setTxtClr1('black');setTxtClr2('black');setTxtClr3('black');setTxtClr4('white');setTxtClr5('black');changeText("₹2336");changeT("₹9345");setColor1("white");setColor2("white");setColor3("white");setColor5("white");amount("₹20000");profit("0.232%");sValue(20000);vLink(f4.l4);}}>₹20000</button>
              <button id ='5'  className="gbutton" style={{background:color5,color:txtclr5,cursor:'pointer'}}  onClick={()=> {setColor5("#147CE5");setTxtClr1('black');setTxtClr2('black');setTxtClr3('black');setTxtClr4('black');setTxtClr5('white');changeText("₹2920");changeT("₹11681");setColor1("white");setColor2("white");setColor3("white");setColor4("white");amount("₹25000");profit("0.29%");sValue(25000);vLink(f5.l5);}}>₹25000</button>
              
              <b style={{fontWeight:400,color:'white',fontFamily:'Roboto',marginTop:7}}>Return on Investment</b>
              <Box 
                
                sx = {theme => ({ [theme.breakpoints.up('sm')]:{marginTop:2,width : 362,marginLeft:1.5, height: 55,backgroundColor: 'white' },
                      [theme.breakpoints.between('0','600')]:{marginTop:1,width : 279.16,marginLeft:1.5, height: 55,backgroundColor: 'white'}
                      })}
              >
              
                <div className="in">
                  <div className="block1">
                  <p>Minimum</p><br/>
                  <div className="inb">
                  <p >{buttonText}</p>
                  </div>
                  </div>
                
                  <div className="block2">
                    <p>Maximum</p><br/>
                    <div className="inb">
                    <p>{buttonT}</p>
                    </div>
                    </div>
                </div>
               
                
                </Box>
           </div>
         </Box>
      <div>
        
      </div>
      </div>
      
      
      <Slider 
              sx = {theme => ({ [theme.breakpoints.up('sm')]:{width:350},
              [theme.breakpoints.between('0','600')]:{width:275,color:'primary'}
              })}
              componentsProps={{ thumb: { className: 'thumb' } }}
              min={5000} max={25000} step={5000} className="slider" 
              value={value} aria-label="1000" valueLabelDisplay="auto"  onChange={getValue} />

            
      
        <div className="bbox">
          <div className="p1">
          <span>Investment Amount</span><br />
          <span><b>{amountText}</b></span>
          </div>
          <div className="p2">
          <span>Profit Percentage</span><br />
          <span><b>{profitText}</b></span>
          </div> 
        </div>

        {/* <hr style={{border: 0,height: 0,borderTop: '1px solid rgba(0, 0, 0, 0.1)',borderBottom: '1px solid rgba(255, 255, 255, 0.3)', margin:'1% 4% -2% 4%'}}/>
         */}
        <div className='note'>
        <p>You will be investing {amountText} and the profit for the
        given amount is {profitText} for the early 1000 units.</p>
        </div>
        {/* <hr style={{border: 0,height: 0,borderTop: '1px solid rgba(0, 0, 0, 0.1)',borderBottom: '1px solid rgba(255, 255, 255, 0.3)',margin:'-2% 4% 0% 4%'}}/>
         */}
        <div className="note">

        <p><b>Note:</b>&nbsp;Untouched Investment is not crowdfunding, we are taking investment amount from the network of known people.</p>
        <a href={link} target="_blank"><button >Proceed</button></a>
        <br />
        <div className="redirect">
        <p>You will be redirected to Razorpay payments gateway page</p>
        </div>
        </div>
        
        
      </Box>
      <p className='terms__condition' >*Terms and Conditions</p>
      </div>
  );
}































